export const formatPrice = (price: number = null): string => {
  if (!price) {
    return "";
  }

  if (price === Math.floor(price)) {
    return price.toString();
  }

  return Number(price).toFixed(2);
};
